import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { ApiService, AlertService, PermissionService } from 'src/app/services';
import { GlobalListComponent } from 'src/app/shared/global-list';
import { config } from 'src/config';
import {InviteStatusApiEnums, InviteStatusEnums} from 'src/app/enums/invite-status.enums';
import { LoginService } from 'src/app/services/new-login-service';
import { InviteStatusDto, ResendInviteDto, SendInviteDto } from 'src/app/models/models';

@Component({
  selector: 'app-guardian',
  templateUrl: './guardian.component.html',
  styleUrls: ['/src/app/views/shared-style.scss']
})
export class GuardianComponent extends GlobalListComponent implements OnInit {
  tableConfigAndProps = {};
  dataSource = new MatTableDataSource();
  buttonHeaderProps: any;

  inputData = {
    'imageColumn': 'profilePicture',
    'actionColumn': 'Actions',
    'expandColumn': 'expandable',
    'firstColumn': 'No.',
    'lastColumn': '',
    'roundedTable': false,
    'hasSwitch': false,
    'buttonEvent': "output"
  }

  constructor(protected router: Router, protected apiService: ApiService, protected _route: ActivatedRoute, protected alertService: AlertService, protected permissionsService: PermissionService, protected _loginService: LoginService) {
    super(router, apiService, alertService, permissionsService);
    this.actionButtons =
      [
        { buttonLabel: "Edit", buttonRoute: "guardian", visibility: true},
        //  this.permissionsService.getPermissionsBySubModuleName('Child Management', 'Booking Manager').update, hide: true },
        { buttonLabel: "View", buttonRoute: "guardian", visibility: true},
        // , this.permissionsService.getPermissionsBySubModuleName('Child Management', 'Booking Manager').read, hide: true },
        { buttonLabel: "Delete", type: 'delete', buttonRoute: "guardian", visibility: true },
      ]
    this.headerButtons = [
      { buttonLabel: "Add New", color: "#E2AF2A", buttonRoute: "guardian/add", isMultiple: false, visibility: this.permissionsService.getPermissionsByModuleName('Child Management').create },
    ]
    this.columnHeader = {
      'id': 'ID', 'type': 'Account Type', 'title': 'Title', 'name': 'Name', 'dateOfBirth': 'Date of Birth', 'address': 'Address', 'firstLanguage': 'Primary Language', 'nationalInsuranceNumber': 'National Insurance', 'status': "Status" ,'Actions': 'Actions'
    };
    this.tableConfigAndProps = {
      ActionButtons: this.actionButtons,
      inputData: this.inputData, columnHeader: this.columnHeader, dataSource: this.dataSource,
    };

    this.buttonHeaderProps = {
      headingLabel: "Parent/Guardian ",
      ActionButtons: this.headerButtons,
      hasButton: true,
      hasHeading: true,
      labelMargin: '10px',
      textclass: 'text-bolder text-color',
      margin: '0px',
      hasFilters: true,
      searchConfig: { label: 'Search', key: 'search', value: '' },
      filterArray: [
        {
          label: 'Sort by ', type: 'sort', key: 'noSortOrder', selected: 'All',
          options: [
            { key: 'All', value: 'All', label: 'All' },
            { key: 'ASC', value: 'ASC', label: 'Ascending' },
            { key: 'DESC', value: 'DESC', label: 'Descending' }
          ]
        },
      ]
    };

    this.listApi = config.base_url_slug + 'view/guardians';
    // this.getList()
    super.ngOnInit();

    this.isMultiple = false;
  }

  async afterListResponse() {
    const emails = this.dataItems.map(el => el.email);
    const inviteStatusPayload : InviteStatusDto = {
      emails: [... new Set(emails)]
    }
    
    let inviteStatusResponse = null;
    if(inviteStatusPayload.emails.length){
      inviteStatusResponse = await this.getInviteStatus(inviteStatusPayload);
    }
    
    this.dataItems.forEach(element => {
      // element['startTime'] = element.startTime == 0 || element.startTime == null ? '-' : moment(new Date(element.startTime * 1000)).format("hh:mm A");
      // element['endTime'] = element.endTime == 0 || element.endTime == null ? '-' : moment(new Date(element.endTime * 1000)).format("hh:mm A");

      element['title'] = element.title != null ? element.title.charAt(0).toUpperCase() + element.title.substr(1).toLowerCase() : '-';
      element['name'] = element.type ? (element.type == "other" ? element.organizationName != null ? element.organizationName : '-' : element.name != null ? element.name : '-') : '-';
      element['firstLanguage'] = element.languageLabel != null ? element.languageLabel : '-';
      element['nationalInsuranceNumber'] = element.nationalInsuranceNumber != null ? element.nationalInsuranceNumber : '-';
      element['dateOfBirth'] = element.dateOfBirth != null ? moment(new Date(element.dateOfBirth)).format(config.cmsDateFormat) : '-';
      element['type'] = element.type ? element.type.charAt(0).toUpperCase() + element.type.substr(1).toLowerCase() : ''
      element['address'] = element.address != null ? element.address : '-';

      // Status fetching logic here
      // element['status'] = element.status ? InviteStatusEnums.INVITE_PENDING : '-';
      // inviteStatusResponse
      if(!inviteStatusResponse){
        return ;
      }  
      const currParent = inviteStatusResponse?.data.find(p => p.email === element.email);
        if(currParent){
          if(currParent.status === InviteStatusApiEnums.ONBOARDED){
            element['status'] = InviteStatusEnums.ONBOARDED
          }
          else if(
            currParent.status === InviteStatusApiEnums.INVITE_RESEND || 
            currParent.status === InviteStatusApiEnums.INVITE_SENT ){
            element['status'] = InviteStatusEnums.INVITE_SENT
          }
          else{
            element['status'] = InviteStatusEnums.INVITE_PENDING
          }
        }else{
            element['status'] = InviteStatusEnums.INVITE_PENDING
        }

    });


    this.tableConfigAndProps = {
      ActionButtons: this.actionButtons,
      inputData: this.inputData,
      columnHeader: this.columnHeader,
      dataSource: new MatTableDataSource(this.dataItems),
      pagination: this.pagination,
      onlyDelete: true,
      hasSendInvite: true
    };
    // this.title = this.title + " (" + this.pagination.count + ")"
  }

  async getInviteStatus(parents: InviteStatusDto){
    try {
      const inviteStatusResponse = await this._loginService.getInviteStatus(parents);
      if(!inviteStatusResponse.success){
        console.log("Api unsuccessfull in invoice listing ========> ", inviteStatusResponse.message);
        return;
      }
      return inviteStatusResponse;
    } catch (error) {
      throw error
    }
  }
  actionButtonOutput(event) {
    console.log(event);
    // this.alertService.alertError("Error", event.item.type);
    if(event.item.type == "sendInvite"){
      const sendInvitePayload : SendInviteDto = {
        ...event.row,
      }
      this._loginService.sendInvite(sendInvitePayload).then((response) => {
        if(response.success){
          this.alertService.alertSuccess('SUCCESS','Invite sent successfully')
        }else{
          this.alertService.alertError('ERROR',response.message)
        }
      })
      return;
    }
    else if(event.item.type == "resendInvite"){
      const resendInvitePayload : ResendInviteDto = {
        email: event.row.email
      }
      this._loginService.resendInvite(resendInvitePayload).then((response) => {
        if(response.success){
          this.alertService.alertSuccess('SUCCESS','Invite resent successfully')
        }else{
          this.alertService.alertError('ERROR',response.message)
        }
      })
      return;
    }
    else if (event.item.type === "delete") {
      event.item['buttonRoute'] = 'guardian';
      this.onDelete(event.row, event.item);
    }
    else {
      this.router.navigateByUrl(`/main/guardian/${event.row.id}/view`);
    }
  }
}
